import * as React from "react";

import { cn } from "utils/cn";

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export const Card = React.forwardRef<HTMLDivElement, DivProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-ui="card"
    className={cn(
      "rounded-card border border-border bg-surface text-foreground shadow-card",
      className
    )}
    {...props}
  />
));
Card.displayName = "Card";

export interface CardHeaderProps extends Omit<DivProps, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  /** Buttons aligned to the right of the title. */
  actions?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  description,
  actions,
  className,
  children,
  ...props
}) => (
  <div
    className={cn("flex flex-wrap items-start justify-between gap-3 px-5 pt-5", className)}
    {...props}
  >
    <div className="min-w-0 space-y-1">
      {title && <h3 className="text-base font-semibold leading-6 tracking-tight">{title}</h3>}
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
      {children}
    </div>
    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
  </div>
);

export const CardBody: React.FC<DivProps> = ({ className, ...props }) => (
  <div className={cn("px-5 py-5", className)} {...props} />
);

export const CardFooter: React.FC<DivProps> = ({ className, ...props }) => (
  <div
    className={cn(
      "flex items-center justify-end gap-2 border-t border-border bg-surface-muted/50 px-5 py-3 rounded-b-card",
      className
    )}
    {...props}
  />
);
